import React, { useEffect, useState } from "react";

import { GET_ALL_ARTICLES } from "api";
import useFetch from "utils/hooks/useFetch";

import { motion } from "framer-motion";

// Icons
import ArrowRightIcon from "assets/icons/ArrowRightIcon";
import SearchIcon from "assets/icons/SearchIcon.png";
// import FilterIcon from "assets/icons/FilterIcon.png";
import SortbyIcon from "assets/icons/SortbyIcon.png";
// import ClickedFilterIcon from "assets/icons/ClickedFilterIcon.png";
import ClickedSortbyIcon from "assets/icons/ClickedSortbyIcon.png";

// Helpers
import { formSortQuery } from "../helpers/format-queries";
import useToastMessage from "helpers/toast-message";

const Articles = () => {
  const { showError } = useToastMessage();
  const { fetch: getAllArticles } = useFetch(GET_ALL_ARTICLES);

  let autocompleteTimer;

  // const [onClickedFilterBtn, setOnClickedFilterBtn] = useState(false);
  const [onClickedSortbyBtn, setOnClickedSortbyBtn] = useState(false);

  const [articles, setArticles] = useState([]);

  const [filterValue, setFilterValue] = useState({
    sortById: "DESC",
    sortByArticleTitle: null,
    search: "",
  });

  const [activeLanguage, setActiveLanguage] = useState("en");

  const fetchAllArticles = (queries) => {
    getAllArticles({ query: queries })
      .then((data) => {
        setArticles(data);
      })
      .catch((err) => {
        showError(err?.data?.message);
      });
  };

  const handleOnChangeSearchVal = (e) => {
    if (autocompleteTimer) {
      clearTimeout(autocompleteTimer);
    }
    let val = e.target.value;
    autocompleteTimer = setTimeout(
      () => setFilterValue({ ...filterValue, search: val }),
      1000
    );
  };

  const handleFilterBtn = (e, key1, key2) => {
    let finalFilter = filterValue;
    // let checked = e.target.checked;
    if (key1 === "sortById") {
      finalFilter = {
        ...finalFilter,
        sortById: key2,
        sortByArticleTitle: null,
      };
    } else if (key1 === "sortByArticleTitle") {
      finalFilter = {
        ...finalFilter,
        sortByArticleTitle: key2,
        sortById: null,
      };
    }
    // else {
    //   finalFilter = {
    //     ...finalFilter,
    //     type: {
    //       ...finalFilter.type,
    //       [`${key2}`]: checked,
    //     },
    //   };
    // }
    setFilterValue(finalFilter);
  };

  useEffect(() => {
    let objSortQuery = {
      column: filterValue.sortById
        ? "id"
        : filterValue.sortByArticleTitle
        ? "title_idn"
        : "",
      state: filterValue.sortById || filterValue.sortByArticleTitle || "",
    };
    let queries = {
      search: filterValue.search,
      sort: formSortQuery(objSortQuery),
    };
    fetchAllArticles(queries);
  }, [filterValue]);

  return (
    <section>
      <div className="space-y-8 app-main-container">
        <p className="pt-3 pb-2 text-2xl font-bold text-center md:pt-6 md:pb-4 md:text-3xl xl:text-4xl text-app-dark-blue">
          Articles
        </p>
        <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-start">
          {/* Search Bar */}
          <div className="w-full bg-gray-100 sm:w-auto rounded-2xl">
            <div className="flex items-center p-3">
              <img src={SearchIcon} alt="Search" className="w-6 h-6 mr-3" />
              <input
                onChange={(e) => handleOnChangeSearchVal(e)}
                placeholder="Search article..."
                type="text"
                className="w-full bg-gray-100 border-transparent focus:border-transparent focus:ring-0 focus:outline-none"
              />
            </div>
          </div>

          {/* Filter & Sort Buttons */}
          <div className="relative flex flex-col w-full gap-2 mb-4 sm:w-auto">
            <div className="flex flex-wrap items-center justify-center gap-3 sm:justify-end">
              {/* Filter Button */}
              {/* <button
                className={`rounded-2xl ${
                  onClickedFilterBtn ? "bg-app-orange" : "bg-gray-100"
                }`}
                onClick={() => {
                  setOnClickedFilterBtn(!onClickedFilterBtn);
                  setOnClickedSortbyBtn(false);
                }}
              >
                <div className="flex items-center gap-2 px-6 py-2">
                  <img
                    src={onClickedFilterBtn ? ClickedFilterIcon : FilterIcon}
                    alt="Filter"
                    className="w-6 h-6"
                  />
                  <span className={onClickedFilterBtn ? "text-white" : ""}>
                    Filter
                  </span>
                </div>
              </button> */}

              {/* Sort By Button */}
              <button
                className={`rounded-2xl ${
                  onClickedSortbyBtn ? "bg-app-orange" : "bg-gray-100"
                }`}
                onClick={() => {
                  setOnClickedSortbyBtn(!onClickedSortbyBtn);
                  // setOnClickedFilterBtn(false);
                }}
              >
                <div className="flex items-center gap-2 px-6 py-2">
                  <img
                    src={onClickedSortbyBtn ? ClickedSortbyIcon : SortbyIcon}
                    alt="Sort by"
                    className="w-6 h-6"
                  />
                  <span className={onClickedSortbyBtn ? "text-white" : ""}>
                    Sort by
                  </span>
                </div>
              </button>

              {/* Language switch */}
              <div>
                <label className="inline-flex items-center mr-3 cursor-pointer sm:mr-5">
                  <span className="mr-2 text-base font-bold text-black sm:text-lg md:text-xl">
                    EN
                  </span>
                  <input type="checkbox" value="" className="sr-only peer" />
                  <div
                    onClick={() =>
                      setActiveLanguage(activeLanguage === "en" ? "id" : "en")
                    }
                    className="relative w-[36px] h-5 sm:w-11 sm:h-6 md:w-[52px] md:h-7 
                    peer-focus:outline-none rounded-full peer
                    peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                    peer-checked:after:border-white
                    after:content-[''] after:absolute after:top-[2px] after:start-[2px]
                    after:bg-white after:border-gray-300 after:border after:rounded-full
                    after:h-4 after:w-4 sm:after:h-5 sm:after:w-5 md:after:h-6 md:after:w-6
                    after:transition-all bg-app-orange"
                  />
                  <span className="ml-2 text-base font-bold text-black sm:text-lg md:text-xl">
                    ID
                  </span>
                </label>
              </div>
            </div>

            {/* Filter Dropdown */}
            {/* {onClickedFilterBtn && (
              <div className="absolute z-10 w-full p-4 mt-2 shadow-lg top-full bg-app-orange rounded-2xl sm:w-64">
                <div className="mb-2 font-bold text-white">
                  By Method of Learning
                </div>
                <div className="my-2 border-t border-b border-white" />
                <div className="flex flex-col gap-2">
                  {["Online", "Offline", "Hybrid (Online and Offline)"].map(
                    (label) => (
                      <label
                        key={label}
                        className="flex items-center text-white"
                      >
                        <input
                          type="checkbox"
                          name={label}
                          checked={filterValue?.type?.[label]}
                          onChange={(e) =>
                            handleFilterBtn(e, "type", label.toLowerCase())
                          }
                          className="mr-2 border-transparent outline-none bg-app-orange"
                        />
                        {label}
                      </label>
                    )
                  )}
                </div>
              </div>
            )} */}

            {/* Sort Dropdown */}
            {onClickedSortbyBtn && (
              <div className="absolute right-0 z-10 w-full p-4 mt-2 shadow-lg top-full bg-app-orange rounded-2xl sm:w-64">
                {[
                  {
                    label: "A - Z",
                    value: ["sortByArticleTitle", "ASC"],
                  },
                  {
                    label: "Z - A",
                    value: ["sortByArticleTitle", "DESC"],
                  },
                  { label: "Newest Added", value: ["sortById", "DESC"] },
                  { label: "Oldest", value: ["sortById", "ASC"] },
                ].map(({ label, value }) => (
                  <button
                    key={label}
                    className="w-full py-1 text-left text-white"
                    onClick={(e) => handleFilterBtn(e, value[0], value[1])}
                  >
                    {label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {articles && Array.isArray(articles) && articles.length > 0 ? (
          <div className="grid grid-cols-1 gap-8 pt-2 pb-6 md:grid-cols-2 md:gap-12 md:pt-4 md:pb-12">
            {articles.map((article, i) => {
              return (
                <motion.div
                  key={i}
                  layoutId={`card-${article.id}`}
                  className="bg-gray-100"
                >
                  <div className="flex flex-col gap-6 p-8 md:gap-8">
                    <motion.p
                      className="text-xl font-bold capitalize text-app-orange/80 md:text-2xl lg:text-3xl line-clamp-2 md:min-h-[70px]"
                      layoutId={`title-${article.id}`}
                    >
                      {activeLanguage === "en" && article?.title_en
                        ? article?.title_en
                        : activeLanguage === "id" && article?.title_idn
                        ? article?.title_idn
                        : article?.title_en || article?.title_idn}
                    </motion.p>
                    <p className="text-sm text-justify md:text-base xl:text-lg line-clamp-5 lg:line-clamp-6 md:min-h-[120px] lg:min-h-[150px] xl:min-h-[170px]">
                      {activeLanguage === "en" && article?.short_description_en
                        ? article?.short_description_en
                        : activeLanguage === "id" &&
                          article?.short_description_idn
                        ? article?.short_description_idn
                        : article?.short_description_en ||
                          article?.short_description_idn}
                    </p>
                    <div className="flex items-center space-x-3">
                      {/* Circle avatar */}
                      <div className="w-10 h-10 rounded-full">
                        <img
                          src={article.author_img_url}
                          alt={`Author-${i + 1}`}
                          className="object-cover w-full rounded-full"
                        />
                      </div>
                      {/* Text box */}
                      <div className="px-1 py-1 rounded ">
                        <p className="text-sm font-medium text-black sm:text-base md:text-md">
                          Written by <b>{article.author_name}</b>
                        </p>
                      </div>
                    </div>
                    <a
                      className="flex items-center gap-2 font-bold"
                      href={`/articles/details/${article.id}`}
                    >
                      <p className="text-sm md:text-base xl:text-lg">
                        Learn More
                      </p>
                      <ArrowRightIcon className="w-3 h-3 sm:w-4 sm:h-4 fill-black" />
                    </a>
                  </div>
                  <motion.div
                    className="h-[200px] sm:h-[300px] md:h-[400px] lg:h-[500px] w-full overflow-hidden mb-8"
                    layoutId={`image-${article.id}`}
                  >
                    <img
                      src={article.article_img_url}
                      alt={`article-${i + 1}`}
                      className="object-contain w-full h-full"
                    />
                  </motion.div>
                </motion.div>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center w-full gap-5 py-10">
            <img
              src={SearchIcon}
              alt="search icon"
              style={{ width: "100px", height: "auto" }}
            />
            <div className="text-2xl font-semibold">No article yet</div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Articles;
